import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-user-trip-details',
  templateUrl: './user-trip-details.component.html',
  styleUrls: ['./user-trip-details.component.scss'],
})
export class UserTripDetailsComponent  implements OnInit {

  tripDetailsForm!: FormGroup

  constructor(
    private _globalService: GlobalService,
    private _fb: FormBuilder,
    private _router: Router,
    private _inputValidationService: InputValidationsService
  ) { }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm(){    
    this.tripDetailsForm = this._fb.group({
      startDate: [null, Validators.required],
      days: [0, [Validators.required, this._inputValidationService.valueNotZeroValidator()]],
      startLocation: ['', Validators.required],
      endLocation: ['', Validators.required],
      noOfGuests: [null, Validators.required]
    });

    
    let tripDetails = this._globalService.getUserTripDetails();
    if(tripDetails){
      this.tripDetailsForm.patchValue(tripDetails);
    }
  }

  handlePrediction(location: string){
    this.tripDetailsForm.get('endLocation')?.setValue(location);
  } 

  today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }

  onSubmit(){
    this._globalService.setUserTripDetails(this.tripDetailsForm.value);
    this._router.navigate(['/user-preferences']);
  }

}
